import React from "react"

export default function Navbar(){
    return(
        <div className = "nav-bar">
            🌐My Travel Journal🌐
        </div>
    )
}